import { Icon, Typography, Modal, Button, URLDetail, Skeleton } from "@/components/atoms";
import { useOperator } from "@/hooks";
import { useGetAppLinksQuery } from "@/redux/apis/config/linksAndDocuments";
import { useAppSelector } from "@/redux/hooks";
import { registrationSelector } from "@/redux/slices/marketing/selectors";
import { copyToClipboard } from "@/utils";

interface InviteDriversModalProps {
  open: boolean;
  onClose: () => void;
}

export const InviteDriversModal = ({ open, onClose }: InviteDriversModalProps) => {
  const { providerCode } = useOperator();
  const { isFetching } = useGetAppLinksQuery();
  const { appLinks } = useAppSelector(registrationSelector);
  const appDownload = appLinks.find((link) => link.document.slug === "app-driver");

  const renderHeader = () => (
    <div className="sm:flex sm:items-start">
      <div className="mt-3 w-full text-center sm:mt-0 sm:text-left">
        <div className="flex flex-row items-center">
          <Typography variant="title" className="flex-1">
            Invite Drivers
          </Typography>
          <Icon name="close" isCustom className="flex cursor-pointer justify-end" onClick={onClose} />
        </div>
      </div>
    </div>
  );

  const renderAppDownloadSection = () => {
    const link = appDownload?.document.link;

    if (!link) {
      return (
        <div className="flex flex-col gap-y-3">
          <div className="flex items-center gap-x-2">
            <Typography variant="paragraph" className="font-medium">
              App Download Link
            </Typography>
            <Icon isCustom name="app-google-playstore" size="sm" />
            <Icon isCustom name="app-ios" size="sm" />
          </div>
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            App download link not configured
          </Typography>
        </div>
      );
    }

    return (
      <div className="flex flex-col gap-y-3">
        <div className="flex items-center gap-x-2">
          <Typography variant="paragraph" className="font-medium">
            App Download Link
          </Typography>
          <Icon isCustom name="app-google-playstore" size="sm" />
          <Icon isCustom name="app-ios" size="sm" />
        </div>

        <div className="flex flex-col lg:flex-row lg:items-center bg-neutral-surface-gray p-2 justify-between rounded-lg">
          <div className="flex flex-col">
            <URLDetail href={link} />
            <div className="ml-9 flex flex-row items-center gap-x-2">
              <Typography variant="paragraph" className="text-neutral-dark-gray">
                Transport Provider Code:
              </Typography>
              <Typography variant="action" className="uppercase text-neutral-black">
                {providerCode}
              </Typography>
            </div>
          </div>
          <Button
            variant="tertiary"
            startIcon="Copy"
            className="!text-info hover:bg-info-light"
            size="sm"
            onClick={() => copyToClipboard(link)}
          >
            Copy
          </Button>
        </div>
      </div>
    );
  };

  // TODO: Email Invitation API
  // This would allow sending invitations directly via email with the app download link
  // const renderEmailSection = () => (
  //   <div className="flex flex-col gap-y-2">
  //     <Typography variant="paragraph" className="font-medium">
  //       Email(s)
  //     </Typography>
  //     <MultiEmailInput emails={emails} onChange={setEmails} placeholder="Enter Email(s)" />
  //     <Typography variant="paragraph" className="text-neutral-dark-gray">
  //       You can enter multiple email addresses separated by commas
  //     </Typography>
  //   </div>
  // );

  // const renderButtons = () => (
  //   <div className="mt-4">
  //     <Button size="lg" variant="primary" onClick={handleInvite} disabled={emails.length === 0 || isSubmitting} className="w-full">
  //       Invite Driver(s)
  //     </Button>
  //   </div>
  // );

  return (
    <Modal open={open} onClose={onClose} className="w-[85vw] md:w-[550px] lg:w-[550px]">
      {renderHeader()}
      <div className="flex flex-col gap-y-6 py-4">
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          Share the driver registration link to invite them. They need to complete the registration to join the system.
        </Typography>

        {isFetching ? <Skeleton /> : renderAppDownloadSection()}
        {/* {renderEmailSection()} */}
      </div>
      {/* {renderButtons()} */}
    </Modal>
  );
};
